import Button from "devextreme-react/button";
import dxDataGrid from "devextreme/ui/data_grid";


export default function ColumnChooserButton(props: { dataGrid: dxDataGrid }) {

	return (
		<Button
			text="Column Chooser"
			icon="column-chooser"
			onClick={() => {
				props.dataGrid.showColumnChooser();
			}} >
		</Button>
	)
}